// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Scene_3_wrapper__3erIT"};